/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceReconciliationRunUploadedByDto } from './InvoiceReconciliationRunUploadedByDto';
export type InvoiceReconciliationRunResponseDto = {
    id: string;
    status: InvoiceReconciliationRunResponseDto.status;
    uploadedAt: string;
    originalFileName: string;
    fileSize?: number | null;
    contentType?: string | null;
    totalRows: number;
    successRows: number;
    failedRows: number;
    errorMessage?: string | null;
    startedAt?: string | null;
    finishedAt?: string | null;
    uploadedBy: InvoiceReconciliationRunUploadedByDto;
};
export namespace InvoiceReconciliationRunResponseDto {
    export enum status {
        PENDING = 'PENDING',
        PROCESSING = 'PROCESSING',
        COMPLETED = 'COMPLETED',
        FAILED = 'FAILED',
    }
}

